/*
 * @Description: 试用期绩效考核审批
 * @Author: 杨志航
 * @Date: 2026-01-22 15:11:51
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Drawer,
  DatePicker,
  Input,
  Button,
  message,
  Switch,
  Select,
  Alert,
  Icon,
  Popconfirm,
  Tooltip,
} from 'antd'
import Auth from '@/components/AuthMiddleware'
import { parseSearch, allTrim, filterParams, cryptoParamsIntoUrl } from '@/utils'
import { jobTypeList } from '@/utils/constant'
import { Link } from 'react-router-dom'
import AddProbation from '../module/AddProbation'
import CorpFilter from '@/components/CorpFilter'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const { RangePicker } = DatePicker
const dateFormat = 'YYYY-MM-DD'
const auditDepartmentList = [
  { id: 1, name: '内控部'},
  { id: 2, name: '绩效部'},
]
const assessmentMethodList = [
  { id: 1, name: '试用期考核表'},
  { id: 2, name: '等级销售模版'},
]

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const Main = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const { history, match, location } = props
  const search = parseSearch(location.search)
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [editData, setEditData] = useState({})
  const [authList, setAuthList] = useState([])//按钮权限
  const [departmentList, setDepartmentList] = useState([])
  const [addVisible, setAddVisible] = useState(false)
  const [shouldMe, setShouldMe] = useState(false)
  const [auditStatusList, setAuditStatusList] = useState([])
  const [jobPostList, setJobPostList] = useState([])
  const corpFilterRef = useRef(null)

  useEffect(() => {
    resetParams()
    const { bizno } = search
    if (bizno) {
      setFieldsValue({
        bizno
      })
      searchParams.bizno = bizno
    }
    getSearchData()
    getPageAuth()
    getList()
  }, [])

  const getSearchData = () => {
    Promise.all([
      api.getAuditStatusList({ type: 55 }),
      api.getJobPostList({ limit: global.paramsLimit }),
      api.getSelectDepartmentList({ limit: global.paramsLimit })
    ]).then(list => {
      setAuditStatusList(list[0])
      setJobPostList(list[1].list)
      setDepartmentList(list[2].list)
    })
  }

  //按钮权限
  const getPageAuth = () => {
    api.getPageAuth().then(list => {
      setAuthList(list)
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getAchProbationReviewList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    corpFilterRef.current.reset()
    resetFields()
    setShouldMe(false)
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.joiningDate && vals.joiningDate.length === 2) {
          vals.joiningDateMin = vals.joiningDate[0].format(dateFormat)
          vals.joiningDateMax = vals.joiningDate[1].format(dateFormat)
        }
        delete vals.joiningDate
        const { shouldMe, companyId } = searchParams
        if (shouldMe) {
          vals.shouldMe = shouldMe
        }
        if (companyId) {
          vals.companyId = companyId
        }
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  const handleAdd = () => {
    setEditData({})
    setAddVisible(true)
  }

  const handleEdit = data => {
    setEditData(data)
    setAddVisible(true)
  }

  const onSetShouldMe = checked => {
    setShouldMe(checked)
    if (checked) {
      searchParams.shouldMe = 1
    } else {
      delete searchParams.shouldMe
    }
    getList()
  }

  const handleDel = id => {
    setLoading(true)
    api.delAchProbationReview({
      id
    }).then(() => {
      message.success('删除成功')
      getList()
    }).catch(() => { setLoading(false) })
  }

  const onChangeCorp = data => {
    searchParams.page = currentPage = 1
    if (data[0]) {
      searchParams.companyId = data[0].id
    } else {
      delete searchParams.companyId
    }
    getList()
  }

  return <>
    <div className="search-doc-wrap">
      <CorpFilter onChange={onChangeCorp} ref={corpFilterRef} />
      <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
        <div className="form-box">
          <FormItem label="员工姓名">
            {getFieldDecorator('name')(<Input placeholder="请输入员工姓名" />)}
          </FormItem>
          <FormItem label="入职部门">
            {getFieldDecorator('departmentId')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                departmentList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="审批状态">
            {getFieldDecorator('auditStatus')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                auditStatusList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="预计入职时间">
            {getFieldDecorator('joiningDateMin')(<RangePicker
              placeholder={['开始时间', '结束时间']}
            />)}
          </FormItem>
          <FormItem label="岗位名称">
            {getFieldDecorator('jobPostId')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                jobPostList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="岗位类别">
            {getFieldDecorator('jobType')(<Select 
              placeholder="请选择"
              allowClear
            >
              {
                jobTypeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="审核部门">
            {getFieldDecorator('auditDepartment')(<Select 
              placeholder="请选择"
              allowClear
            >
              {
                auditDepartmentList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="招聘业务编号">
            {getFieldDecorator('bizno')(<Input placeholder="请输入招聘业务编号" />)}
          </FormItem>
          <FormItem label="考核方式">
            {getFieldDecorator('assessmentMethod')(<Select 
              placeholder="请选择"
              allowClear
            >
              {
                assessmentMethodList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Switch 
            checkedChildren="待审批" 
            unCheckedChildren="待审批" 
            disabled={loading} 
            onChange={onSetShouldMe} 
            className="shouldme-switch-btn" 
            checked={shouldMe}
          />
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="add-wrap">
        <Auth auths={authList} code="level-sale-temp">
          <Button type="primary" onClick={() => history.push('/ach/probationachaudit/saletemplate')}>等级销售模板管理</Button>
        </Auth>
        <Auth auths={authList} code="add">
          <Button type="primary" onClick={handleAdd} style={{ marginLeft: 15 }}>新建</Button>
        </Auth>
      </div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"  
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 'max-content' }}
      >
        <Column 
          title="员工姓名" 
          dataIndex="name" 
          fixed="left"
          render={(text, record) => <Link to={cryptoParamsIntoUrl('/hr/recruit/detail', { id: record.rId })}>{text}</Link>}
        />
        <Column title="预计入职时间" dataIndex="joiningDate" />
        <Column title="实际入职时间" dataIndex="determineJoinDate" />
        <Column 
          title="审批状态" 
          dataIndex="auditStatusName" 
          render={(text, record) => <Link to={cryptoParamsIntoUrl(`${match.path}/detail`, { id: record.id })}>{text}</Link>}
        />
        <Column title="入职主体" dataIndex="companyName" />     
        <Column title="入职事业群" dataIndex="groupName" />
        <Column title="入职部门" dataIndex="departmentName" />
        <Column title="岗位名称" dataIndex="jobPostName" />
        <Column title="岗位类别" dataIndex="jobTypeName" />
        <Column 
          title="入职项目" 
          dataIndex="projectsName" 
          render={(text, record) => (
            <>
              {text && text.map((item, index) => <div key={index}>{item}</div>)}
            </>
          )} 
        />
        <Column title="试用期级别" dataIndex="probationaryLevel" />
        <Column title="转正级别" dataIndex="regularLevel" />
        <Column title="手机号码" dataIndex="mobile" />
        <Column title="是否管理" dataIndex="isManagerName" />
        <Column title="是否实习生" dataIndex="isInternName" />
        <Column title="审核部门" dataIndex="auditDepartmentName" />     
        <Column title="考核方式" dataIndex="assessmentMethodName" />
        <Column title="反馈人" dataIndex="addByName" />
        <Column title="反馈时间" dataIndex="addTime" />
        <Column title="审批时间" dataIndex="auditTime" />
        <Column 
          title="招聘业务编号" 
          dataIndex="bizno" 
          render={(text, record) => <Link to={cryptoParamsIntoUrl('/hr/recruit/detail', { id: record.rId })}>{text}</Link>}
        />
        <Column 
          title="操作" 
          key="set" 
          fixed="right" 
          width={100} 
          align="center"
          render={(text, record) => (
            <>
              <Tooltip title="在新页面打开详情页" placement="bottom">
                <Link target='_blank' to={cryptoParamsIntoUrl(`${match.path}/detail`, { id: record.id })}>
                  <Icon type="folder-open" style={{ color: '#1890FF', fontSize: '16px' }} />
                </Link>
              </Tooltip>
              {record.userAuth?.allowRakeUp && (
                <Tooltip title="编辑" placement="bottom">
                  <Icon type="edit" style={{ color: '#1890ff', marginLeft: '10px' }} onClick={() => handleEdit(record)} />
                </Tooltip>
              )}
              {record.userAuth?.allowDelete && (
                <Popconfirm title="确认删除吗？" cancelText="取消" okText="确认" onConfirm={() => handleDel(record.id)}>
                  <Tooltip title="删除" placement="bottom">
                    <Icon type="delete" style={{ color: 'red', marginLeft: '10px' }} />
                  </Tooltip>
                </Popconfirm>
              )}
            </>
          )} 
        />
      </Table>
    </div>
    <Drawer
      title="试用期员工绩效考核"
      width={600}
      onClose={() => setAddVisible(false)}
      visible={addVisible}
      destroyOnClose={true}
    >
      <AddProbation 
        setAddVisible={setAddVisible}
        getList={getList}
        bizno={search.bizno}
        editData={editData}
      />
    </Drawer>
  </>
}

export default Form.create()(Main)
